import { Component } from '@angular/core';

@Component({
    selector: 'app-pricing-details-header',
    templateUrl: './pricing-details-header.component.html',
    styleUrls: ['./pricing-details-header.component.scss'],
    standalone: false,
})
export class PricingDetailsHeaderComponent {
    imgSrc: string = '../../../../../assets/media/logos/pricing-icon-black.png';

    constructor() {}

    onMouseOver(): void {
        this.imgSrc = '../../../../../assets/media/logos/pricing-icon-yellow.png';
    }

    onMouseOut(): void {
        this.imgSrc = '../../../../../assets/media/logos/pricing-icon-black.png';
    }
}
